import api from "./api";

// -------------------- REJECTION RECORDS --------------------

// GET ALL (full list — kept for compatibility)
export const fetchRejections = async () => {
  const res = await api.get("/rejections/records/");
  return res.data;
};

// GET DATE RANGE RECORDS (default: last 7 days)
export const fetchRejectionsByRange = async (startDate, endDate, farm) => {
  const params = new URLSearchParams();
  if (startDate) params.append("start_date", startDate);
  if (endDate) params.append("end_date", endDate);
  if (farm) params.append("farm", farm);
  
  const res = await api.get(`/rejections/records/range_records/?${params.toString()}`);
  return res.data;
};

// CREATE
export const createRejection = async (data) => {
  const res = await api.post("/rejections/records/", data);
  return res.data;
};

// DELETE
export const deleteRejection = async (id) => {
  const res = await api.delete(`/rejections/records/${id}/`);
  return res.data;
};

// FULL SUMMARY (HISTORICAL)
export const fetchRejectionSummary = async () => {
  const res = await api.get("/rejections/records/summary/");
  return res.data;
};

// TODAY SUMMARY (DASHBOARD USE)
export const fetchTodayRejectionSummary = async () => {
  const res = await api.get("/rejections/records/today_summary/");
  return res.data;
};
export const fetchRejectionReasons = async () => (await api.get('/rejections/reasons/')).data;
export const createRejectionReason = async (name) => (await api.post('/rejections/reasons/', { name })).data;

export const updateRejectionReason = async (id, name) => (await api.patch(`/rejections/reasons/${id}/`, { name })).data;
export const deleteRejectionReason = async (id) => api.delete(`/rejections/reasons/${id}/`);
